import ProcessEmpty from 'assets/img/process-empty.svg';
import { LogsStatusCell } from 'components/molecules/tableCell/systemLogs';
import { SystemLogGeneral } from 'container/services/systemLogs/ISystemLogsRepo';

import { GridColumn } from '../grid/types';

const LOGS_PER_PAGE = 16;

const TEMPLATES_TYPE = 'log_list';

enum LOGS_SOURCES {
  PRINT_RENDER = 'print_render',
  EMAIL_POLLING = 'email_polling',
  FTP_POLLING = 'ftp_polling',
  BARCODE_IMPORTER = 'barcode_importer',
  ORDER_ENTRY = 'order_entry',
  MAINTENANCE_PAYABLES = 'maintenance_payables',
  AUTOMATED_INDEXING = 'automated_indexing',
  DRIVER_SETTLEMENTS = 'driver_settlements',
  GENERAL_PAYABLES = 'general_payables',
}

const STATIC_COLUMNS = ['createdAt', 'event', 'logType', 'description'];

export enum ToolbarAction {
  saveAs = 'saveAS',
  templates = 'templates',
}

export const LOG_DEFAULT_COLUMNS: GridColumn<SystemLogGeneral>[] = [
  {
    headerText: 'Date and Time',
    field: 'createdAt',
    allowSorting: true,
    width: 150,
    template: (logData: SystemLogGeneral) =>
      new Date(logData.createdAt).toLocaleString(),
  },
  {
    headerText: 'Type',
    field: 'logType',
    allowSorting: true,
    width: 100,
    template: LogsStatusCell,
  },
  {
    headerText: 'Event',
    field: 'event',
    allowSorting: true,
  },
  {
    headerText: 'Description',
    field: 'description',
    width: 400,
    allowSorting: true,
  },
  {
    headerText: 'Task ID',
    field: 'taskId',
  },
  {
    headerText: 'Invoice ID',
    field: 'invoiceId',
  },
  {
    headerText: 'Batch ID',
    field: 'batchId',
  },
];

export const useStrings = (log_type: string) => {
  'use memo';

  const TEXTS = {
    BACK: 'Back',
    PAGE_TITLE: `${log_type} Logs`,
    LOGS_EXPIRATION: 'Application log events are only retained for 60 days',
    SEARCH_PLACEHOLDER: 'Search in description... ',
    SEARCH_NAME_PARAM: 'name',
    ALT_EMPTY: `${log_type} logs empty`,
  };

  const EMPTY_STATE_IMG_CONFIG = {
    imgSource: ProcessEmpty,
    imgAlt: TEXTS.ALT_EMPTY,
  };

  const GRID_EMPTY_STATE = {
    imgConfig: EMPTY_STATE_IMG_CONFIG,
    title: `There are no ${log_type.toLowerCase()} logs to show`,
  };

  return {
    TEXTS,
    EMPTY_STATE_IMG_CONFIG,
    GRID_EMPTY_STATE,
  };
};

export { STATIC_COLUMNS, LOGS_PER_PAGE, LOGS_SOURCES, TEMPLATES_TYPE };
